import React from "react";
import {useSelector} from "react-redux";
import FirstStepsLoggedIn from "./FirstStepsLoggedIn";
import FirstStepsNotLoggedIn2 from "./FirstStepsNotLoggedIn2";


const FirstSteps2 = () => {
    

    const currentUser = useSelector(st => st.currentUser);
    const loggedIn = currentUser && currentUser.username;

    return(
        <>

            {loggedIn && <FirstStepsLoggedIn/>}
            {!loggedIn && <FirstStepsNotLoggedIn2/>}

        </>
        
    )
};
export default FirstSteps2;

